import classes from "./ProductThumbNail.module.scss";
import { Link } from "react-router-dom";
const ProductThumbNail = ({ thumbNailImgURL, shopProdName, linkPath }) => {
  return (
    <div className={classes.thumbnail_container}>
      <img src={thumbNailImgURL} alt="" className={classes.thumbnail_img} />
      <div className={classes.shop_product}>
        <span className={classes.shop_product_name}>{shopProdName}</span>
        <div className={classes.shop}>
          <Link to={linkPath} className={classes.shop_speaker_text}>
            SHOP
          </Link>{" "}
          <svg width="8" height="12" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.322 1l5 5-5 5"
              stroke="#D87D4A"
              strokeWidth="2"
              fill="none"
              fillRule="evenodd"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ProductThumbNail;
